



































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Spinner } from 'spin.js';
import { CheckoutStore, CheckoutState } from '@/store/checkoutstate';
import { CheckoutModel } from '@/models/Cart/Checkout';
import { ApiService } from '@/services/ApiService';
import CartViewB2c from '@/components/Checkout/CartViewB2C.vue';
import { GaItem } from '@/models/Cart/Cart';
import axios from 'axios';
import { matomoEvent } from '@/mixins/matomoEvent';

@Component({
    components: {
        CartViewB2c
    }
})
export default class MiniCart extends Vue {
    get cart() {
        return CheckoutStore.cart;
    }

    public showCart: boolean;
    protected spinner: Spinner;
    protected lastClickedNode = null;
    private body: HTMLElement | null = document.querySelector('#body');
    public showShareInput: boolean = false;
    public email: string = '';
    private valideEmail: boolean = true;
    private shareIsOk: boolean = false;
    private addedRemovedItems: Array<GaItem> = [];
    private addedRemovedItemsValue: number = 0;

    constructor() {
        super();
        this.spinner = new Spinner({ scale: 0.5 });
        this.showCart = false;
    }

    private mounted() {
        document.addEventListener('mousedown', this.clickHandler);
    }

    private destroyed() {
        document.removeEventListener('mousedown', this.clickHandler);
    }

    public toggleCart() {
        this.showCart = !this.showCart;
        if (this.showCart) {
            this.gaEvent('view_cart');
        }
    }

    protected created() {
        const self = this;
        const $el = self.$el as HTMLElement;
        self.spinner.spin($el);
        ApiService.getMiniCart().then(response => {
            if (response && response.data) {
                const payload: CheckoutState = {
                    cart: response.data
                };
                CheckoutStore.saveState(payload).then(() => {
                    /*nothing*/
                });
            }
            self.spinner.stop();
        });
    }

    @Watch('cart')
    onCartChanged(val: any, oVal: any) {
        if (this.body !== null) {
            if (val.quantity !== '0') {
                if (!this.body.classList.contains('sticky')) {
                    this.body.classList.add('sticky');
                }
            } else {
                if (this.body.classList.contains('sticky')) {
                    this.body.classList.remove('sticky');
                }
            }
        }

        if (parseInt(val.quantity) != parseInt(oVal.quantity) && typeof oVal.quantity !== 'undefined') {
            const concatArray = val.items.concat(oVal.items);

            this.addedRemovedItems = concatArray.filter(
                (element: GaItem, index: number, self: Array<GaItem>) =>
                    self.filter(
                        x =>
                            ((x.item_id && x.item_id === element.item_id) ||
                                (x.item_variant && x.item_variant === element.item_variant)) &&
                            x.quantity !== element.quantity
                    ).length > 0
            );
            if (this.addedRemovedItems.length > 1) {
                let q = this.addedRemovedItems[0].quantity - this.addedRemovedItems[1].quantity;
                if (q < 0) q *= -1;
                this.addedRemovedItems = [{ ...this.addedRemovedItems[0], quantity: q }];
            }
            if (!this.addedRemovedItems.length) {
                this.addedRemovedItems = concatArray.filter(
                    (element: GaItem, index: number, self: Array<GaItem>) =>
                        self.filter(
                            x =>
                                (x.item_id && x.item_id === element.item_id) ||
                                (x.item_variant && x.item_variant === element.item_variant)
                        ).length === 1
                );
            }
            this.addedRemovedItemsValue = 0;
            this.addedRemovedItems.forEach(x => {
                this.addedRemovedItemsValue += (x.price - x.discount) * x.quantity;
            });

            this.gaEvent(parseInt(val.quantity) > parseInt(oVal.quantity) ? 'add_to_cart' : 'remove_from_cart');
        }
    }

    private gaEvent(gaEvent: string): void {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
            event: gaEvent,
            ecommerce: {
                currency: this.cart.currency,
                value:
                    gaEvent === 'add_to_cart' || gaEvent === 'remove_from_cart'
                        ? this.addedRemovedItemsValue
                        : this.cart.cartTotal,
                items:
                    gaEvent === 'add_to_cart' || gaEvent === 'remove_from_cart'
                        ? this.addedRemovedItems
                        : this.cart.items
            }
        });
    }

    private clickHandler(e: any) {
        const minicartCart = document.querySelector('.minicart-cart');
        const minicartButton = document.querySelector('.minicart-button');
        
        const clickedOutsideCart = minicartCart && !minicartCart.contains(e.target);
        const clickedOutsideButton = minicartButton && !minicartButton.contains(e.target);

        // If the cart is open and the user clicks outside both the cart and the button, close it
        if (this.showCart && clickedOutsideCart && clickedOutsideButton) {
            this.showCart = false;
        }
    }

    public toggleShareCartInput() {
        this.showShareInput = !this.showShareInput;
    }

    private trackBeginCheckout(): void {
        matomoEvent('Ecommerce Funnel', 'Step 3 - Begin Checkout', 'Cart');
    }

    public sendShareCart() {
        const requestContext = (window as any).__litium.requestContext;
        this.valideEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email);
        if (this.valideEmail) {
            axios
                .post(`/api/cart/share?email=${this.email}`, null, {
                    headers: {
                        'litium-request-context': JSON.stringify(requestContext)
                    }
                })
                .then(response => {
                    if (response.status === 200) {
                        this.shareIsOk = true;
                    }
                });
        } else {
            this.shareIsOk = false;
        }
    }
    private enter(element: HTMLElement) {
        const width = getComputedStyle(element).width;

        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const height = getComputedStyle(element).height;

        element.style.width = '';
        element.style.position = '';
        element.style.visibility = '';
        element.style.height = '0';
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = height;
        });
    }
    private afterEnter(element: HTMLElement) {
        element.style.height = 'auto';
    }
    private leave(element: HTMLElement) {
        const height = getComputedStyle(element).height;

        element.style.height = height;
        getComputedStyle(element).height;
        requestAnimationFrame(() => {
            element.style.height = '0';
        });
    }
}
